import { useParams, Link } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import { categories, articles } from "@/mocks/articles";

const categoryHeaderImages: Record<string, string> = {
  entertainment: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20film%20reel%20elements%2C%20magazine%20editorial%20aesthetic%2C%20soft%20gradient%20background%2C%20modern%20clean%20design%2C%20entertainment%20vibe&width=600&height=500&seq=category-header-entertainment&orientation=landscape",
  influencer: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20camera%20and%20ring%20light%20elements%2C%20magazine%20editorial%20aesthetic%2C%20soft%20gradient%20background%2C%20modern%20design&width=600&height=500&seq=category-header-influencer&orientation=landscape",
  social: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20cityscape%20elements%2C%20magazine%20editorial%20aesthetic%2C%20soft%20gradient%20background%2C%20modern%20clean%20design&width=600&height=500&seq=category-header-social&orientation=landscape",
  exclusive: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20magnifying%20glass%20elements%2C%20investigative%20aesthetic%2C%20soft%20gradient%20background%2C%20modern%20design&width=600&height=500&seq=category-header-exclusive&orientation=landscape",
  positive: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20heart%20and%20sun%20elements%2C%20editorial%20aesthetic%2C%20soft%20gradient%20background%2C%20hopeful%20design&width=600&height=500&seq=category-header-positive&orientation=landscape",
  funny: "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20composition%20with%20comedic%20elements%2C%20playful%20aesthetic%2C%20soft%20gradient%20background%2C%20fun%20modern%20design&width=600&height=500&seq=category-header-funny&orientation=landscape",
};

const categoryDescriptions: Record<string, { title: string; subtitle: string; description: string; statNumber: string; statLabel: string }> = {
  entertainment: {
    title: "娱乐圈",
    subtitle: "明星八卦 · 影视爆料",
    description: "聚焦娱乐圈最新动态，明星恋情、影视内幕、综艺八卦、音乐圈热点，为你呈现最全面的娱乐圈吃瓜内容。从顶流明星到新生代艺人，从片场趣闻到颁奖典礼，娱乐吃瓜不迷路。",
    statNumber: "12,860",
    statLabel: "篇独家报道",
  },
  influencer: {
    title: "网红圈",
    subtitle: "主播黑料 · 直播内幕",
    description: "追踪网红圈最新风向，带货翻车、主播纠纷、MCN内幕、短视频平台热点，为你揭开网红经济的真实面貌。从千万粉丝大V到新兴网红，第一时间掌握圈内动态。",
    statNumber: "8,520",
    statLabel: "篇网红爆料",
  },
  social: {
    title: "社会热点",
    subtitle: "热点追踪 · 实时爆料",
    description: "紧跟社会热点事件，深度追踪新闻背后的故事。从城市街头到网络空间，从公共事件到民间故事，用独特的吃瓜视角解读社会百态，还原事件真相。",
    statNumber: "6,340",
    statLabel: "篇热点追踪",
  },
  exclusive: {
    title: "独家黑料",
    subtitle: "深度挖掘 · 第一手消息",
    description: "吃瓜网王牌栏目，集结全网最具价值的独家爆料。我们的调查团队深入挖掘，为你带来别人看不到的内幕消息。商界秘闻、娱乐圈潜规则、行业黑幕，这里只发真料。",
    statNumber: "3,210",
    statLabel: "篇独家内幕",
  },
  positive: {
    title: "正能量",
    subtitle: "暖心故事 · 感人瞬间",
    description: "吃瓜不止有八卦，还有温暖和感动。正能量频道汇集社会中的暖心故事、凡人善举和感动瞬间。在喧嚣的吃瓜世界中，留一片温暖的心灵栖息地。",
    statNumber: "4,780",
    statLabel: "篇正能量故事",
  },
  funny: {
    title: "搞笑吃瓜",
    subtitle: "轻松一刻 · 欢乐吃瓜",
    description: "吃瓜也要开开心心！搞笑吃瓜频道汇集最有趣的八卦趣闻、翻车现场、魔性视频和搞笑吐槽。放下压力，轻松一笑，做最快乐的吃瓜群众。",
    statNumber: "9,150",
    statLabel: "篇搞笑内容",
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const catArticles = articles.filter((a) => a.categorySlug === slug);
  const desc = categoryDescriptions[slug || ""] || categoryDescriptions.entertainment;

  if (!category) {
    return <div className="flex items-center justify-center h-screen">分类不存在</div>;
  }

  const categorySchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": `${category.name} - 吃瓜网`,
    "description": category.description,
    "url": `http://claekqe.cn/category/${slug}`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "吃瓜网",
      "url": "http://claekqe.cn/"
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(categorySchema)}
      </script>

      <Header />
      <main>
        <section className="relative bg-gradient-to-b from-background-800 to-background-900 pt-24 pb-20 md:pt-32 md:pb-28 px-4 md:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: "首页", href: "/" },
                  { label: category.name },
                ]}
              />
            </div>

            <div className="mb-4">
              <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 text-white/90 text-sm font-medium">
                {desc.subtitle}
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
              {desc.title}
            </h1>

            <p className="text-white/65 text-base md:text-lg leading-relaxed max-w-3xl mb-16">
              {desc.description}
            </p>

            <div className="flex flex-col md:flex-row items-start gap-10 md:gap-20">
              <div className="w-full md:w-2/5">
                <img
                  src={categoryHeaderImages[slug || "entertainment"] || categoryHeaderImages.entertainment}
                  alt={category.name}
                  className="w-full rounded-2xl object-cover"
                />
              </div>
              <div className="w-full md:w-3/5">
                <span className="font-heading text-7xl md:text-8xl lg:text-9xl font-black text-white/10 leading-none">
                  {desc.statNumber}
                </span>
                <p className="text-white/50 text-lg mt-2 mb-6">{desc.statLabel}</p>
                <p className="text-white/70 text-sm md:text-base leading-relaxed">
                  吃瓜网{category.name}频道每日更新，为你提供最新最全的{category.name}爆料内容。我们的编辑团队全天候追踪热点，确保你不错过任何精彩内容。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 text-center mb-12 md:mb-16">
              本类最新大瓜
            </h2>

            {catArticles.length === 0 ? (
              <p className="text-center text-foreground-500 py-20">暂无相关内容，敬请期待</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {catArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group relative rounded-2xl overflow-hidden aspect-[4/5] cursor-pointer"
                  >
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                      <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium mb-3">
                        {article.category}
                      </span>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug line-clamp-2 mb-2">
                        {article.title}
                      </h3>
                      <p className="text-white/70 text-xs md:text-sm line-clamp-2">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-4 mt-4 text-white/50 text-xs">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line"></i>
                          {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                        </span>
                        <span>{article.publishDate}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}